import React, { useContext, useEffect, useState } from 'react'
import { ScrollView, StyleSheet, Text, View } from 'react-native'
import { RouteProp, useRoute } from '@react-navigation/native'
import { NecropsyContext } from '../../../../context/Necropsy/Provider'
import { NecropsyRoutes } from '../../../../navigator/types'
import { TemplatePage } from '../../../../components/TemplatePage'
import { globalStyle } from '../../../../theme/global'
import { FormHeader } from '../../components/FormHeader'
import { PhotoCard } from '../../components/PhotoCard'
import { Separator } from '../../../../components/Separator'
import { corporateColor, textColor } from '../../../../theme/colors'
import { DataForm } from '../../../../context/Necropsy/types'
import { useTranslation } from 'react-i18next'

export const Review = () => {
  const { getRecordById } = useContext(NecropsyContext)
  const { t } = useTranslation()
  const route = useRoute<RouteProp<NecropsyRoutes, 'Review'>>()

  const [record, setRecord] = useState<DataForm>()

  useEffect(() => {
    if (route.params.recordId) {
      setRecord(getRecordById(route.params.recordId))
    }
  }, [route.params.recordId])

  return (
    <>
      <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title={t('Resumen')}>
        <View style={[globalStyle.viewContainer, { padding: 0 }]}>
          {record && (
            <ScrollView>
              <FormHeader
                title={t('Resumen')}
                customStyle={{ padding: 16 }}
                hasBg
                hasCaseNumber
                config={{
                  centerName: record.centerName!,
                  date: record.date!,
                  formId: record.formId!,
                }}
              />

              <PhotoCard
                title={t('Foto externa general')}
                time={record.externalPhoto.dateTime?.time ?? ''}
                uri={record.externalPhoto.uri!}
              />
              <Separator />

              <PhotoCard
                title={t('Foto interna general')}
                time={record.internalPhoto.dateTime?.time ?? ''}
                uri={record.internalPhoto.uri!}
                hasBg
              />
              <Separator />

              <PhotoCard
                title={t('Foto interna branquias')}
                time={record.gillPhoto.dateTime?.time ?? ''}
                uri={record.gillPhoto.uri!}
              />
              <Separator />
              {Object.values(record.additionalPhotos).length > 0 && (
                <>
                  {Object.entries(record.additionalPhotos).map(([key, photo], index) => (
                    <PhotoCard
                      key={photo.uri}
                      title={t('Foto adicional')}
                      time={photo.dateTime?.time ?? ''}
                      uri={photo.uri!}
                      hasBg={index % 2 === 0}
                    />
                  ))}
                </>
              )}

              <Separator />

              {record.comments !== null && record.comments.length > 0 && (
                <View style={styles.containerText}>
                  <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 8 }}>
                    <Text
                      style={{
                        color: corporateColor,
                        fontSize: 18,
                        fontWeight: '500',
                        marginRight: 4,
                      }}
                    >
                      {t('Comentarios')}
                    </Text>
                  </View>

                  <Text style={{ color: textColor }}>{record.comments}</Text>
                </View>
              )}
            </ScrollView>
          )}
        </View>
      </TemplatePage>
    </>
  )
}

const styles = StyleSheet.create({
  containerText: {
    marginVertical: 20,
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
})
